import { SCHEDULE_SKIP_REASONS } from '@croissants/domain/vocabulary';
/**
 * Why a selected morning of a stay cannot be served (GST-010, GST-098 -
 * finding F-24).
 *
 * The review names each morning it could not price with one of these, and a
 * checkout whose morning went between the review and the Pay button refuses
 * the whole stay naming it (`stay_morning_unavailable`). A closed set on the
 * wire - never `error.message` free text. The tuple is shared with domain.
 */

import { z } from 'zod';

export const StaySkipReason = z.enum(SCHEDULE_SKIP_REASONS);
export type StaySkipReason = z.infer<typeof StaySkipReason>;
